import { Link } from "react-router-dom";
import { ConversationWordmark } from "../OlliLogo";
import { AUTH_PATHS } from "./signupState";

/**
 * Split layout: form on the left, a composed preview of the Olli product on the right
 * (design: components/AuthLayout.tsx). Auth pages render outside the app shell, so the
 * root carries the `olli` scope class the generated CSS needs.
 *
 * Footer links: Terms and Privacy are the public site's pages (the same URLs the data-deletion page
 * and the lead form builder use); Help writes to support@getolliai.com.
 */
export const TERMS_URL = "https://getolliai.com/terms-of-service";
export const PRIVACY_URL = "https://getolliai.com/privacy-policy";
export const HELP_URL = "mailto:support@getolliai.com";

export function AuthLayout({ children, aside, asideTitle, topRight }) {
  return (
    <div className="olli flex min-h-screen bg-paper font-sans text-ink">
      <div className="flex min-h-screen w-full flex-col px-6 py-6 sm:px-12 lg:w-[46%] lg:px-16 xl:px-20">
        <div className="flex items-center justify-between">
          <Link to={AUTH_PATHS.signin} aria-label="Olli AI">
            <ConversationWordmark tone="white" className="h-8 w-auto" />
          </Link>
          {topRight}
        </div>
        <div className="flex flex-1 flex-col justify-center py-10">
          <div className="w-full max-w-md">{children}</div>
        </div>
        <div className="flex gap-5 text-caption text-muted">
          <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-ink">Terms of service</a>
          <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="hover:text-ink">Privacy policy</a>
          <a href={HELP_URL} className="hover:text-ink">Help</a>
        </div>
      </div>
      <div className="hidden p-3 lg:block lg:w-[54%]">
        <div className="sticky top-3 flex h-[calc(100vh-24px)] flex-col items-center justify-center gap-8 overflow-hidden rounded-xl bg-[image:var(--gradient-morning)] p-10">
          {asideTitle && (
            <p key={asideTitle} className="w-full max-w-xl animate-fade-in text-h2 font-semibold">
              {asideTitle}
            </p>
          )}
          {aside}
        </div>
      </div>
    </div>
  );
}
